import React from 'react'
const goldArrow = require('../../../../../assets/studentPreChecks/gold_arrow.svg')
import cx from "classnames"
import './PointingArrow.scss'

export default function PointingArrow({ pointingDirection, classNameProp }) {

    const classes = cx({
        'pointing-arrow': true,
        'up': pointingDirection === 'up',
        'down': pointingDirection === 'down',
        'left': pointingDirection === 'left',
        'right': pointingDirection === 'right',
        [classNameProp]: classNameProp
    })

    return (
        <div className={`${classes}`}><img src={goldArrow} alt=""/></div>
    )
}
